export enum DatetimeUnit {
  DAY = 'day',
  MONTH = 'month',
  YEAR = 'year',
  HOUR = 'hour',
  MINUTE = 'minute',
  SECOND = 'second',
  AMPM = 'a'
};
